module.exports = __webpack_public_path__ + "static/media/email.9b9bd59b.svg";